import axios from "axios";

const getBackendUrl = () => {
    if (process.env.REACT_APP_BACKEND_URL !== undefined) {
        return process.env.REACT_APP_BACKEND_URL;
    }
    if (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
        return "";
    }
    return "http://localhost:8000";
};

const BACKEND_URL = getBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    if (typeof window !== "undefined") {
        const token = localStorage.getItem("session_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

export default api;
